import { render, staticRenderFns } from "./Interests.vue?vue&type=template&id=1b5a0104"
import script from "./Interests.vue?vue&type=script&lang=js"
export * from "./Interests.vue?vue&type=script&lang=js"
import style0 from "./Interests.vue?vue&type=style&index=0&id=1b5a0104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports